import React, { useState, useEffect } from 'react';

const Exterior = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  
  // Function to handle iframe load completion
  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  // Set a timeout for slow connections
  useEffect(() => {
    // Backup timeout to hide loader if iframe onLoad doesn't trigger
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 8000); // 8 seconds timeout

    return () => clearTimeout(timeoutId);
  }, []);

  // Handle resize and mobile height issues
  useEffect(() => {
    const handleResize = () => {
      // Use this trick to get the actual viewport height on mobile
      setViewportHeight(window.innerHeight);
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    };

    // Set it initially
    handleResize();
    
    // Update on resize and orientation change
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  // Set body/html to proper height when component mounts
  useEffect(() => {
    // Save original styles to restore later
    const originalHtmlStyle = document.documentElement.style.cssText;
    const originalBodyStyle = document.body.style.cssText;
    
    // Set full height on HTML and body
    document.documentElement.style.height = '100%';
    document.body.style.height = '100%';
    document.body.style.margin = '0';
    
    // Only restrict overflow on desktop, not mobile
    if (window.innerWidth > 768) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    
    // Cleanup function to restore original styles when component unmounts
    return () => {
      document.documentElement.style.cssText = originalHtmlStyle;
      document.body.style.cssText = originalBodyStyle;
    };
  }, []);

  return (
    <div className="virtual-tour-container" style={{ height: `${viewportHeight}px` }}>
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p className="loading-text">Loading...</p>
        </div>
      )}
      
      <iframe
        src="https://www.elzonex360.com/360/vasudharini-nest/"
        className={`tour-iframe ${isLoading ? 'hidden' : 'visible'}`}
        title="Vasudharini Nest Exterior"
        onLoad={handleIframeLoad}
        allow="fullscreen; vr; xr-spatial-tracking; accelerometer; gyroscope"
      ></iframe>

      <style jsx="true">{`
        :root {
          --vh: 1vh;
        }
        
        .virtual-tour-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          /* Fallback for browsers that don't support custom properties */
          height: 100vh; 
          /* This is the better solution for mobile */
          height: calc(var(--vh, 1vh) * 100);
          overflow: hidden;
          z-index: 20;
        }
        
        .tour-iframe {
          width: 100%;
          height: 100%;
          border: none;
          transition: opacity 0.5s ease-in-out;
        }
        
        .tour-iframe.hidden {
          opacity: 0;
        }
        
        .tour-iframe.visible {
          opacity: 1;
        }
        
        .loading-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 30;
        }
        
        .spinner {
          width: 48px;
          height: 48px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #EAB308; /* Yellow-500 color */
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 16px;
        }
        
        .loading-text {
          color: #4B5563; /* Gray-600 color */
          font-size: 16px;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Additional mobile-specific adjustments */
        @media screen and (max-width: 768px) {
          .virtual-tour-container {
            position: absolute;
            height: 100%; /* Use dynamic height on mobile */
          }
          
          body, html {
            overflow: auto !important; /* Allow scrolling on mobile if needed */
            overscroll-behavior: none; /* Prevent pull-to-refresh */
          }
        }
      `}</style>
    </div>
  );
};

export default Exterior;